<section class="hero" aria-labelledby="hero-title">
  <div class="hero__copy">
    <p class="hero__kicker">Anonymous conversations, made easy</p>
    <h1 id="hero-title">StrangerYap: meet someone new in one click.</h1>
    <p class="hero__subhead">
      Tap start and we'll connect you with a stranger ready to chat by text,
      voice, or video.
    </p>
    <div class="hero__actions">
      <a class="hero__cta" routerLink="/chat">Start chatting</a>
      <a class="hero__video-cta" routerLink="/video">Video chat</a>
    </div>
    <div class="hero__trust" aria-label="StrangerYap trust facts">
      @for (fact of trustFacts; track fact; let isLast = $last) {
        <span>{{ fact }}</span>
        @if (!isLast) {
          <span class="hero__trust-dot" aria-hidden="true">&#183;</span>
        }
      }
    </div>
  </div>

  <div class="chat-preview" aria-label="Preview of a StrangerYap conversation">
    <div class="chat-preview__topbar">
      <div class="chat-preview__person">
        <span class="chat-preview__avatar">A</span>
        <span>
          <strong>Someone new</strong>
          <small><i></i> Online now</small>
        </span>
      </div>
      <span class="chat-preview__menu" aria-hidden="true">•••</span>
    </div>

    <div class="chat-preview__body">
      <span class="chat-preview__date">Just now</span>
      <div class="chat-preview__message chat-preview__message--them">
        Hey, where are you chatting from?
      </div>
      <div class="chat-preview__message chat-preview__message--you">
        Somewhere between coffee and a good playlist.
      </div>
      <div class="chat-preview__message chat-preview__message--them">
        That sounds like a good place to start.
      </div>
      <div class="chat-preview__matching">
        <span class="chat-preview__pulse"></span>
        Matching you with someone new...
      </div>
    </div>

    <div class="chat-preview__composer">
      <span>Type a message...</span>
      <button type="button" aria-label="Send message" tabindex="-1">
        <span aria-hidden="true">&#8593;</span>
      </button>
    </div>
  </div>
</section>
